export class ApplePayPaymentRequest implements ApplePayJSV14.ApplePayPaymentRequest {
	total: ApplePayJSV14.ApplePayLineItem;
	countryCode: string;
	currencyCode: string;
	merchantCapabilities: ApplePayJS.ApplePayMerchantCapability[];
	supportedNetworks: string[];
	lineItems?: ApplePayJS.ApplePayLineItem[];
	billingContact?: ApplePayJS.ApplePayPaymentContact;
	requiredBillingContactFields?: ApplePayJS.ApplePayContactField[];
	requiredShippingContactFields?: ApplePayJS.ApplePayContactField[];
	shippingContact?: ApplePayJS.ApplePayPaymentContact;
	shippingMethods?: ApplePayJS.ApplePayShippingMethod[];
	shippingType?: ApplePayJS.ApplePayShippingType;
	supportedCountries?: string[];
	applicationData?: string;
	recurringPaymentRequest?: ApplePayJSV14.ApplePayRecurringPaymentRequest;
}
